import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';

const Help = () => {
  return (
    <div className="help">
      <div>
        <FontAwesomeIcon icon={faCircleQuestion} fontSize={24} />
      </div>
      <div>Clic pentru a deschide/inchide asistentul aplicatiei</div>
      <div>
        <FontAwesomeIcon icon={faPowerOff} fontSize={24} />
      </div>
      <div>
        Clic pentru a iesi din aplicatie. Se revine la ecranul de autentificare
      </div>
      <div>
        <button>Adauga</button>
      </div>
      <div>Adauga tranzactii in luna curenta</div>
      <div>
        <button>Filtreaza</button>
      </div>
      <div>
        Filtreaza tranzactiile dupa 3 criterii: tipul tranzactiei, utilizatorul
        care le-a adaugat si luna in care au fost adaugate
      </div>
      <div>
        <b>Bara de stare</b>
      </div>
      <div>
        Situata deasupra listei tranzactiilor, indica filtrele aplicate
        selectiei curente
      </div>
      <div>
        <b>Lista tranzactiilor</b>
      </div>
      <div>
        <p>- Afiseaza tranzactiile, corespunzator filtrelor aplicate</p>
        <p>
          - Clic pe o tranzactie din lista: devin disponibile optiunile de
          modificare sau stergere a tranzactiei
        </p>
      </div>
      <div>
        <button>Modifica</button>
      </div>
      <div>Modifica tranzactia selectata. Poti modifica doar suma</div>
      <div>
        <button>Sterge</button>
      </div>
      <div>Sterge tranzactia selectata</div>
    </div>
  );
};

export default Help;
